// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3UgIF","vLegacy":"SelectSecondary_vLegacy__3t-oI","error":"SelectSecondary_error__1I6sl","disabled":"SelectSecondary_disabled__6th9m"};